<!--净化器清洗管理组件-->
<template>
    <el-dialog
      :title="mode==='view'?'查看':'处理'"
      :visible.sync="dialogFormVisible"
      width="60%"
      :before-close="handleClose"
      top="20px"
    >
    <div style="overflow-y: auto; height: 70vh">
      <div class="block">
        <el-timeline>
          <el-timeline-item timestamp="数据情况" placement="top">
            <el-card>
              <el-table
                :data="[row]"
                size="mini"
                border
              >
                <el-table-column
                  prop="acquit_at"
                  label="报警日期"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    {{dateFormatDate(scope.row.acquit_at)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CompliantDays"
                  label="报警类型"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    <span>净化器未清洗</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="stove_num"
                  label="灶头数"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.stove_num || "-" }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="filter_wash_day"
                  label="净化器清洗周期"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.filter_wash_day || "-" }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="wash_number"
                  label="累计清洗次数"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.wash_number || "-" }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="end_data"
                  label="上次清洗日期"
                  align="center"
                  header-align="center"
                >
                </el-table-column>
              </el-table>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="报警核实&第三方巡检" placement="top">
            <el-card>
              <h4>核实状态: <template v-if="info.status == 0"><span style="color:#aaaaaa;margin-left:38px;">核实中</span></template><template v-else><span style="color:#4091ff;margin-left:38px;">已核实</span></template></h4>
              <el-form
                :model="formData"
                :rules="formRule"
                ref="form"
                size="mini"
                label-width="108px"
                label-position="left"
                :disabled="mode == 'view'"
              >
                <el-form-item prop="process_at" label="核实日期">
                  <el-date-picker
                    placeholder="核实日期"
                    type="date"
                    value-format="timestamp"
                    format="yyyy-MM-dd"
                    v-model="formData.process_at"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  prop="process_reason"
                  label="核实情况"
                >
                  <el-select v-model="formData.process_reason">
                    <el-option label="已清洗未上传记录" value="已清洗未上传记录" />
                    <el-option label="未清洗" value="未清洗" />
                    <el-option label="净化器换新" value="净化器换新" />
                    <el-option label="商家停业" value="商家停业" />
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="process_info"
                  label="处理详情"
                >
                  <el-input
                    type="textarea"
                    autosize
                    v-model.trim="formData.process_info"
                  />
                </el-form-item>
                <el-form-item
                  prop="rectify_date"
                  label="整改期限"
                >
                  <el-select v-model="formData.rectify_date">
                    <el-option label="1" value="1"/>
                    <el-option label="2" value="2"/>
                    <el-option label="3" value="3"/>
                    <el-option label="4" value="4"/>
                    <el-option label="5" value="5"/>
                    <el-option label="6" value="6"/>
                    <el-option label="7" value="7"/>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="processing_address"
                  label="获取定位">
                  <baidu-map
                    class="bm-view"
                    :center="mapCenter"
                    :zoom="mapZoom"
                    ak="770b4c07458f53896ff0abd948755e20"
                    @ready="handleMapReady"
                    v-if="mode == 'edit'"
                  >
                    <bm-geolocation
                      anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                      :showAddressBar="true"
                      :autoLocation="true"
                      @locationSuccess="getPosition"
                    ></bm-geolocation>
                  </baidu-map>
                  <span>{{ formData.processing_address ? formData.processing_address : '暂无定位' }}</span>
                </el-form-item>
                <el-form-item
                  prop="MaintenancePicS"
                  label="处理照片">
                  <template v-if="mode == 'edit' &&  info.status == 0">
                    <el-upload
                      ref="upload"
                      accept=".jpg, .jpeg, .png"
                      list-type="picture-card"
                      :action="upload()"
                      :on-success="handleAvatarSuccess"
                      :on-remove="handleRemove"
                      multiple
                    >
                      <i class="el-icon-plus"/>
                      <div slot="tip">上传照片（支持jpg、jpeg、png）</div>
                    </el-upload>
                  </template>
                  <template v-else>
                    <div v-if="formData.process_pics && formData.process_pics[0]">
                      <el-image v-for="item in formData.process_pics" :key="item" :src="item" :preview-src-list="formData.process_pics" style="width: 100px;height: 100px;margin-left:10px;" />
                    </div>
                  </template>
                </el-form-item>
              </el-form>
              <div style="float:right;padding-bottom:20px;margin-right:20px;" v-if="mode == 'edit' && info.status == 0">
                <el-button type="primary" size="mini" @click.native="handleSubmit(true)">提交</el-button>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item v-if = "info.status != 0 && info.process_reason != '商家停业'" timestamp="整改情况" placement="top">
            <el-card>
              <h4>整改状态: <template v-if="info.rectify_status == 1"><span style="color:#aaaaaa;margin-left:38px;">整改中</span></template><template v-else-if="info.rectify_status == 2"><span style="color:#4091ff;margin-left:38px;">整改完成</span></template><template v-else><span style="color:#660000;margin-left:38px;">整改失败</span></template></h4>
              <h4>整改日期:  <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{fixTime(info.process_at, 0)}}</span><span style="margin-left:20px;color:#aaaaaa;font-weight: 400;">~</span><span style="font-size: 14px;margin-left:20px;color:#aaaaaa;font-weight: 400;">{{fixTime(info.process_at, info.rectify_date)}}</span></h4>
              <template v-if="info.rectify_status >= 1">
                <el-table
                :data="tableHandleData"
                size="mini"
                style="width: 80%;margin-left: 100px"
                border
              >
                <el-table-column
                  prop="AcquitDate"
                  label="日期"
                  align="center"
                  header-align="center"
                />
                <el-table-column
                  prop="WashData"
                  label="清洗日期"
                  align="center"
                  header-align="center"
                />
                <el-table-column
                  prop="IsWash"
                  label="净化器清洗状况"
                  align="center"
                  header-align="center"
                />
              </el-table>
              </template>
            </el-card>
          </el-timeline-item>
          <el-timeline-item v-if="info.rectify_status == 2 && washData.Id > 0" timestamp="净化器清洗记录" placement="top">
            <el-card>
              <h4>监测点: <span style="font-size: 14px;margin-left:50px;color:#aaaaaa;font-weight: 400;">{{row.locale_name}}</span></h4>
              <h4>清洗日期: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{dateFormatDate(washData.EndDate)}}</span></h4>
              <h4>清洗方式: <template v-if="washData.UploadType == 'BusinessStopped'"><span style="color:#aaaaaa;margin-left:38px;">净化器换新</span></template><template v-else-if="washData.UploadType == 'FilterWash'"><span style="color:#4091ff;margin-left:38px;">第三方清洗</span></template><template v-else><span style="color:#4091ff;margin-left:38px;">自主清洗</span></template></h4>
              <div v-if="washData.UploadType == 'FilterWash'">
                <h4>清洗单位: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{washData.WashName}}</span></h4>
              </div>
              <div v-if="washData.LocaleUploadedInfoBeforePicS.length > 0">
                <h4>清洗前: <div style="margin-left:90px;"><el-image v-for="(pic,index) in washData.LocaleUploadedInfoBeforePicS" :key="index" :src="pic" :preview-src-list="washData.LocaleUploadedInfoBeforePicS" style="width: 100px;height: 100px;margin-left:10px;" /></div></h4>
              </div>
              <div v-if="washData.LocaleUploadedInfoPicS.length > 0">
                <h4>清洗后: <div style="margin-left:90px;"><el-image v-for="(pic,index) in washData.LocaleUploadedInfoPicS" :key="index" :src="pic" :preview-src-list="washData.LocaleUploadedInfoPicS" style="width: 100px;height: 100px;margin-left:10px;" /></div></h4>
              </div>
              <div v-if="washData.LocaleUploadedInfoOtherPicS.length > 0">
                <h4>其他材料: <div style="margin-left:90px;"><el-image v-for="(pic,index) in washData.LocaleUploadedInfoOtherPicS" :key="index" :src="pic" :preview-src-list="washData.LocaleUploadedInfoOtherPicS" style="width: 100px;height: 100px;margin-left:10px;" /></div></h4>
              </div>
              <h4>备注: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{washData.Remark}}</span></h4>
            </el-card>
          </el-timeline-item>
          <el-timeline-item v-if="(info.status == 3 || info.status == 2) && info.rectify_status == 3" timestamp="执法管理" placement="top">
            <el-card>
              <h4>处理状态: <template v-if="info.status == 2"><span style="color:#aaaaaa;margin-left:38px;">执法中</span></template><template v-else><span style="color:#4091ff;margin-left:38px;">已执法</span></template></h4>
              <el-form
                :model="formData_1"
                :rules="formRule_1"
                ref="form1"
                size="mini"
                label-width="108px"
                label-position="left"
                :disabled="mode == 'view'"
              >
                <template v-if="eventRecords.length>0">
                  <el-form-item label="处理记录">
                    <el-timeline>
                      <el-timeline-item v-for="item in eventRecords" :key="item.index"  :timestamp="'第'+item.index+'次处理记录'" placement="top">
                        <el-card>
                          <h4>处理日期: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{dateFormat(item.handle_at)}}</span></h4>
                          <h4>处理人员: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{item.handle_name}}</span></h4>
                          <h4>处理措施: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{item.solution}}</span></h4>
                          <div v-if="item.handle_pics.length > 0">
                            <el-image v-for="(pic,index) in item.handle_pics" :key="index" :src="pic" :preview-src-list="item.handle_pics" style="width: 100px;height: 100px;margin-left:10px;" />
                          </div>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-form-item>
                </template>
                <el-form-item prop="handle_at" label="处理日期">
                  <el-date-picker
                    placeholder="处理日期"
                    type="date"
                    value-format="timestamp"
                    format="yyyy-MM-dd"
                    v-model="formData_1.handle_at"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  prop="solution"
                  label="处理措施"
                >
                  <el-input
                    type="textarea"
                    autosize
                    v-model.trim="formData_1.solution"
                  />
                </el-form-item>
                <el-form-item
                  prop="status"
                  label="处理结果"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData_1.status"
                    clearable
                    placeholder='处理结果'
                  >
                    <el-option label="处理中" :value="2"></el-option>
                    <el-option label="已完成" :value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="handle_pics"
                  label="处理照片">
                  <template v-if="mode == 'edit' &&  info.status == 2">
                    <el-upload
                      ref="upload"
                      accept=".jpg, .jpeg, .png"
                      list-type="picture-card"
                      :action="upload()"
                      :on-success="handleAvatar1Success"
                      :on-remove="handle1Remove"
                      multiple
                    >
                      <i class="el-icon-plus"/>
                      <div slot="tip">上传照片（支持jpg、jpeg、png）</div>
                    </el-upload>
                  </template>
                  <template v-else>
                    <div v-if="formData_1.handle_pics && formData_1.handle_pics[0]">
                      <el-image v-for="item in formData_1.handle_pics" :key="item" :src="item" :preview-src-list="formData_1.handle_pics" style="width: 100px;height: 100px;margin-left:10px;" />
                    </div>
                  </template>
                </el-form-item>
              </el-form>
              <div style="float:right;padding-bottom:20px;margin-right:20px;" v-if="mode == 'edit' && info.status == 2">
                <el-button type="primary" size="mini" @click.native="handleSubmit1(true)">提交</el-button>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item v-if="info.rectify_status == 3 && washData.Id > 0" timestamp="净化器清洗记录" placement="top">
            <el-card>
              <h4>监测点: <span style="font-size: 14px;margin-left:50px;color:#aaaaaa;font-weight: 400;">{{row.locale_name}}</span></h4>
              <h4>清洗日期: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{dateFormatDate(washData.EndDate)}}</span></h4>
              <h4>清洗方式: <template v-if="washData.UploadType == 'BusinessStopped'"><span style="color:#aaaaaa;margin-left:38px;">净化器换新</span></template><template v-else-if="washData.UploadType == 'FilterWash'"><span style="color:#4091ff;margin-left:38px;">第三方清洗</span></template><template v-else><span style="color:#4091ff;margin-left:38px;">自主清洗</span></template></h4>
              <div v-if="washData.UploadType == 'FilterWash'">
                <h4>清洗单位: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{washData.WashName}}</span></h4>
              </div>
              <div v-if="washData.LocaleUploadedInfoBeforePicS.length > 0">
                <h4>清洗前: <div style="margin-left:90px;"><el-image v-for="(pic,index) in washData.LocaleUploadedInfoBeforePicS" :key="index" :src="pic" :preview-src-list="washData.LocaleUploadedInfoBeforePicS" style="width: 100px;height: 100px;margin-left:10px;" /></div></h4>
              </div>
              <div v-if="washData.LocaleUploadedInfoPicS.length > 0">
                <h4>清洗后: <div style="margin-left:90px;"><el-image v-for="(pic,index) in washData.LocaleUploadedInfoPicS" :key="index" :src="pic" :preview-src-list="washData.LocaleUploadedInfoPicS" style="width: 100px;height: 100px;margin-left:10px;" /></div></h4>
              </div>
              <div v-if="washData.LocaleUploadedInfoOtherPicS.length > 0">
                <h4>其他材料: <div style="margin-left:90px;"><el-image v-for="(pic,index) in washData.LocaleUploadedInfoOtherPicS" :key="index" :src="pic" :preview-src-list="washData.LocaleUploadedInfoOtherPicS" style="width: 100px;height: 100px;margin-left:10px;" /></div></h4>
              </div>
              <h4>备注: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{washData.Remark}}</span></h4>
            </el-card>
          </el-timeline-item>
          <el-timeline-item v-if="info.status == 3" timestamp="事件完结" placement="top">
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    </el-dialog>
</template>
<script>
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import {
  dateFormater
} from '@/util'
import conf from '@/config'
export default {
  name: "purifierWashViewDialog",
  components: {BaiduMap, BmGeolocation},
  data() {
    return {
      id: null,
      mode: 'view',
      info: {},
      row:{},
      alarmData:{},
      washData:{},
      handleData:{},
      progress: [],
      tableData:[],
      formData: {},
      formData_1: {},
      tableHandleData: [],
      eventRecords:[],
      formRule: {
        process_reason: [{required: true, message: '不可为空'}],
        process_info: [{required: true, message: '不可为空'}],
        process_at: [{required: true, message: '不可为空'}],
        rectify_date: [{required: true, message: '不可为空'}],
      },
      formRule_1: {
        solution: [{required: true, message: '不可为空'}],
        handle_at: [{required: true, message: '不可为空'}],
      },
      mapZoom: 14,
      mapCenter: {lng: 120.306305, lat: 30.424877},
      dialogFormVisible: false,
    }
  },

  methods: {
    fixTime(time, day) {
      if (time) {
        let arr = time.split(" ")
        if (day == 0) {
          return arr[0]
        } else {
          let date = new Date(arr[0]); // 你可以替换为你需要的日期
          date.setDate(date.getDate() + day);
          var y = date.getFullYear();
          var m = date.getMonth() + 1;
          m = m < 10 ? ('0' + m) : m;
          var d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          return y + '-' + m + '-' + d;
        }
      }
    },
    getEventInfo(id) {
      this.eventRecords = []
      this.$get('admin/listEvent/info/' + id,{typ: 2}).then(res => {
        for(var i = 0; i < res.eventHandleRecords.length; i++) {
          res.eventHandleRecords[i].index = i+1
          if (res.eventHandleRecords[i].handle_pics != "") {
            res.eventHandleRecords[i].handle_pics = res.eventHandleRecords[i].handle_pics.split(",")
          } else {
            res.eventHandleRecords[i].handle_pics = []
          }
        }
        this.eventRecords = res.eventHandleRecords
      })
    },
    getData() {
      this.tableHandleData = []
      this.washData = {}
      this.formData = {}
      this.formData_1 = {}
      this.$get('admin/alarmManagement/info/' + this.id).then(res => {
        this.info = res.info
        this.alarmData = res.alarm_data
        this.handleData = res.handle_data
        this.washData = res.locale_uploaded_info
        var proPics = res.info.process_pics.split(',')
        var imgs = []
        for (var i = 0; i < proPics.length; i++) {
          if (proPics[i]) {
            imgs.push(proPics[i])
          }
        }
        this.formData = {
          "process_reason":     res.info.process_reason,
          "process_info":       res.info.process_info,
          "process_at":         res.info.process_at != "-"? Date.parse(new Date(res.info.process_at)):Date.parse(new Date()),
          "rectify_date":       res.info.rectify_date>0?res.info.rectify_date:1,
          "processing_address": res.info.processing_address,
          "process_pics":       imgs,
        }
        if (res.info.rectify_status > 0) {
          var now = new Date().getTime()
          for (var i = 0; i <= res.info.rectify_date; i++) {
            if (this.getDateFromTimestamp(new Date(res.info.process_at).getTime() / 1000 + i*86400) <= this.getDateFromTimestamp(now / 1000)) {
              if (this.dateFormatDate(res.locale_uploaded_info.CreatedAt) == this.getDateFromTimestamp(new Date(res.info.process_at).getTime() / 1000 + i*86400)) {
                this.tableHandleData.push({
                  AcquitDate: this.getDateFromTimestamp(new Date(res.info.process_at).getTime() / 1000 + i*86400),
                  WashData: this.dateFormatDate(res.locale_uploaded_info.EndDate),
                  IsWash: "已清洗"
                })
                break
              } else {
                this.tableHandleData.push({
                  AcquitDate: this.getDateFromTimestamp(new Date(res.info.process_at).getTime() / 1000 + i*86400),
                  WashData: "-",
                  IsWash: "未清洗"
                })
              }
            }
          }
        }
        var handlePics = res.info.handle_pics.split(',')
        var images = []
        for (var i = 0; i < handlePics.length; i++) {
          if (handlePics[i]) {
            images.push(handlePics[i])
          }
        }
        this.formData_1 = {
          "solution":     res.info.solution,
          "handle_at":    res.info.handle_at != "-"? Date.parse(new Date(res.info.handle_at)):Date.parse(new Date()),
          "handle_pics":  images,
          "status":       res.info.status,
        }
      })
      this.getEventInfo(this.id)
    },
    getDateFromTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      return `${year}-${month}-${day}`;
    },
    dealDialog(optType = 'view', row = {}) {
      this.id = row.id
      this.row = row
      this.mode = optType
      this.dialogFormVisible = true
      this.getData()
    },
    handleSubmit1() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              let params = new URLSearchParams()
              var paramData = {
                status:        this.formData_1.status,
                handle_at:     this.formData_1.handle_at / 1000,
                solution:      this.formData_1.solution,
                handle_pics:   this.formData_1.handle_pics.join(','),
              }
              Object.entries(paramData).forEach(([key, val]) => {
                params.append(key, val)
              })
              this.$post('admin/alarmManagement/edit/' + this.id, params)
                .then(() => {
                  setTimeout(()=> {
                    this.$emit('on-refresh')
                  }, 500)
                  this.$message({
                    type: 'success',
                    message: "执法成功"
                  })
                  this.dialogFormVisible = false
                })
            })
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              let params = new URLSearchParams()
              var paramData = {
                status: 1,
                process_reason: this.formData.process_reason,
                process_info:   this.formData.process_info,
                process_at:     this.formData.process_at / 1000,
                rectify_date:   this.formData.rectify_date,
                processing_address: this.formData.processing_address,
                process_pics:       this.formData.process_pics.join(','),
              }
              Object.entries(paramData).forEach(([key, val]) => {
                params.append(key, val)
              })
              this.$post('admin/alarmManagement/edit/' + this.id, params)
                .then(() => {
                  setTimeout(()=> {
                    this.$emit('on-refresh')
                  }, 500)
                  this.$message({
                    type: 'success',
                    message: "核实成功"
                  })
                  this.dialogFormVisible = false
                })
            })
        }
      })
    },
    submit() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
              let { Id, Resolution, MaintenancePicS } = this.formData1
              const Status = 'FINISHED'
              this.$post('admin/updateHealthCodeRecord', { Id, Resolution, Status, MaintenancePicS })
                .then(() => {
                  setTimeout(()=> {
                    this.$emit('on-refresh')
                  }, 500)
                  this.$message({
                    type: 'success',
                    message: "审核成功"
                  })
                  this.dialogFormVisible = false
                })
            })
        }
      })
    },
    submitCheck() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            let { Id, Resolution, Status } = this.formData2
            this.$post('admin/updateHealthCodeRecord', {Id, Resolution, Status,})
              .then(() => {
                setTimeout(()=> {
                  this.$emit('on-refresh')
                }, 500)
                this.$message({
                  type: 'success',
                  message: "审核成功"
                })
                this.dialogFormVisible = false
              })
          })
        }
      })
    },
    handleClose() {
      this.dialogFormVisible = false
      this.formData = {}
      this.formData1 = {}
    },
    upload() {
      return conf.uploadApi + '/uploadToOss'
    },
    handleAvatarSuccess(res, file) {
      this.formData.process_pics.push(res.Data)
    },
    handleRemove(file, fileList) {
      const i = this.formData.process_pics.indexOf(file.response.Data)
      this.formData.process_pics.splice(i, 1)
    },
    handleAvatar1Success(res, file) {
      this.formData_1.handle_pics.push(res.Data)
    },
    handle1Remove(file, fileList) {
      const i = this.formData_1.handle_pics.indexOf(file.response.Data)
      this.formData_1.handle_pics.splice(i, 1)
    },
    handleMapReady() {
      if (this.formData.Lng && this.formData.Lat) {
        this.mapCenter = {lng: this.formData.Lng, lat: this.formData.Lat}
      }
    },
    getPosition(pos) {
      this.formData.Lng = pos.point.lng.toString()
      this.formData.Lat = pos.point.lat.toString()
      this.formData.processing_address = pos.addressComponent['province'] + pos.addressComponent['city'] +
        pos.addressComponent['district'] + pos.addressComponent['street'] +
        pos.addressComponent['streetNumber']
    },
    dateFormat(r) {
      return dateFormater(r, true);
    },
    dateFormatDate(day) {
      var time = day.split(" ")
      return time[0]
    }
  }
}
</script>
<style scoped>
.bm-view {
  width: 100%;
  height: 150px;
}
</style>
